// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import get from 'lodash/get'
import React from 'react'
import { Query } from 'react-apollo'
import withConfirmModal from '../../../common/confirmModal/withConfirmModal'
import Container from '../../../common/container/Container'
import Loader from '../../../common/loader/Loader'
import Pagination from '../../../common/pagination/Pagination'
import Header from '../../header/Header'
import { i18n } from '../../index'
import UserEditDialog from './UserEditDialog'
import css from './Users.css'
import UsersTable from './UsersTable'
import type { User } from './userTypes'
import { fetchUsers } from './usersQueries'
type Props = {
  adminStore: Record<string, any>
}
type State = {
  isDialogOpen: boolean
  data: User
  sFilter: string
  page: number
  perPage: number
}
const defaultUser = {
  givenName: '',
  id: '',
  principalName: '',
  samAccountName: '',
  surname: '',
  name: '',
  userType: 'User',
  defaultPosition: 'Other',
  companyId: null,
}

class Users extends React.Component<Props, State> {
  state = {
    isDialogOpen: false,
    data: defaultUser,
    sFilter: '',
    page: 1,
    perPage: 10,
  }
  onEdit = (data: User) => {
    this.setState({
      data,
    })
    this.openDialog()
  }
  onDelete = (
    onMutate: (...args: Array<any>) => any,
    refetch: (...args: Array<any>) => any,
    id: string,
    userId: string,
  ) => {
    this.props.confirmModal.show(i18n.t('admin.user.deleteConfirmationText'), async (isConfirmed: boolean) => {
      if (isConfirmed) {
        await onMutate({
          variables: {
            id,
            userId,
          },
        })
        refetch()
      }
    })
  }
  openDialog = () => {
    this.setState({
      isDialogOpen: true,
    })
  }
  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
    })
  }
  onPageChange = (page) => {
    this.setState({
      page,
    })
  }
  onPageSizeChange = (perPage) => {
    this.setState({
      page: 1,
      perPage,
    })
  }
  onFilter = (str: string) => {
    this.setState({
      sFilter: str,
      page: 1,
      perPage: str.length > 1 ? 100000 : 10,
    })
  }

  render() {
    const { data, isDialogOpen, page, perPage, sFilter } = this.state
    return (
      <div className={css.listContainer}>
        <Header title={i18n.t('admin.header')} />
        <Container>
          <Typography variant='h6'>{i18n.t('admin.header')}</Typography>
          <div className={css.mainHeader}>
            <Typography variant='h6'>{i18n.t('admin.users')}</Typography>
            <TextField
              id='outlined-search'
              label={i18n.t('common.search')}
              type='search'
              role='search'
              margin='dense'
              variant='outlined'
              value={sFilter}
              onChange={(e) => this.onFilter(e.target.value)}
            />
            <span> </span>
          </div>
          <Query
            query={fetchUsers}
            variables={{
              page,
              perPage,
            }}
          >
            {({ loading, error, data, refetch }) => {
              const paginationProps = {
                total: data && data.users && data.users.total,
                page,
                pageSize: perPage,
                onPageChange: this.onPageChange,
                onPageSizeChange: this.onPageSizeChange,
              }
              return (
                <Loader
                  {...{
                    loading,
                    error,
                  }}
                >
                  {sFilter.length > 1 ? '' : <Pagination {...paginationProps} />}
                  <UsersTable
                    data={
                      sFilter.length > 1
                        ? get(data, 'users.edges', []).filter((row) => {
                            return row.node.name.toLowerCase().indexOf(sFilter.toLowerCase()) > -1
                          })
                        : get(data, 'users.edges', [])
                    }
                    onEdit={this.onEdit}
                    onDelete={this.onDelete}
                    refetch={refetch}
                  />
                  {sFilter.length > 1 ? '' : <Pagination {...paginationProps} />}
                </Loader>
              )
            }}
          </Query>
          <UserEditDialog data={data} isOpen={isDialogOpen} onClose={this.closeDialog} />
        </Container>
      </div>
    )
  }
}

export default withConfirmModal(Users)
